module.exports = __webpack_public_path__ + "static/courtqueen-c03dcfe6d76653ca860e2e6f97ebcc7a.webp";